export default __webpack_public_path__ + "static/media/googleButton.e170b3c3.svg";